import { LocationData } from './Locations'

export const EmployeeLocations = {
  // Employee Platform Locations
  EmployeeDashboard: '/employee/dashboard',

  EmployeeSettings: '/employee/settings',

  EmployeePreTax: {
    Overview: '/employee/pretax',
  },

  EmployeeCarpool: {
    Overview: '/employee/carpool',
    CarpoolDetails: '/employee/carpool/:carpoolGroupId',
    CarpoolRequestDetails:
      '/employee/carpool/:carpoolGroupId/:carpoolRequestId',
  },

  EmployeeGRH: {
    Overview: '/employee/grh',
    Status: '/employee/grh/status',
  },

  EmployeeFlex: {
    Overview: '/employee/flex',
  },

  EmployeeMicromobility: {
    Overview: '/employee/micromobility',
    CheckoutConfirmation: '/employee/micromobility/checkout-confirmation',
  },

  EmployeeTransactions: {
    Overview: '/employee/transactions',
  },

  EmployeeTrips: {
    Overview: '/employee/trips',
    AddTrip: '/employee/trips/add-trip/',
  },

  EmployeeLeaderboards: {
    Overview: '/employee/leaderboards',
  },

  EmployeeOptIn: {
    Overview: '/employee/opt-in',
  },

  EmployeeReimbursement: {
    Overview: '/employee/reimbursement',
  },

  EmployeeConcierge: '/employee/concierge',

  EmployeeTransitPass: {
    Overview: '/employee/transit-pass',
  },
}

export const employeeLocationData: Dictionary<LocationData> = {
  // Employee
  [EmployeeLocations.EmployeeSettings]: {
    title: 'Settings',
    analyticsTitle: 'employee-profile-settings',
  },

  // Employee Dashboard
  [EmployeeLocations.EmployeeDashboard]: {
    title: 'Dashboard',
    analyticsTitle: 'employee-dashboard',
    noPadding: true,
    ignoreMaxWidth: true,
    customHeader: true,
  },

  // Employee PreTax
  [EmployeeLocations.EmployeePreTax.Overview]: {
    title: 'Pre-Tax Benefits',
    analyticsTitle: 'employee-pretax',
  },

  // Employee Carpool
  [EmployeeLocations.EmployeeCarpool.Overview]: {
    title: 'Carpool',
    analyticsTitle: 'employee-carpool',
  },
  [EmployeeLocations.EmployeeCarpool.CarpoolDetails]: {
    title: 'Carpool Details',
    path: [
      EmployeeLocations.EmployeeCarpool.Overview,
      EmployeeLocations.EmployeeCarpool.CarpoolDetails,
    ],
    analyticsTitle: 'employee-carpool',
  },
  [EmployeeLocations.EmployeeCarpool.CarpoolRequestDetails]: {
    title: 'Carpool Request Details',
    path: [
      EmployeeLocations.EmployeeCarpool.Overview,
      EmployeeLocations.EmployeeCarpool.CarpoolDetails,
      EmployeeLocations.EmployeeCarpool.CarpoolRequestDetails,
    ],
    analyticsTitle: 'employee-carpool',
  },

  // Employee GRH
  [EmployeeLocations.EmployeeGRH.Overview]: {
    title: 'Guaranteed Ride Home',
    analyticsTitle: 'employee-grh',
  },
  [EmployeeLocations.EmployeeGRH.Status]: {
    title: 'GRH Status',
    path: [
      EmployeeLocations.EmployeeGRH.Overview,
      EmployeeLocations.EmployeeGRH.Status,
    ],
    analyticsTitle: 'employee-grh',
  },

  // Employee Flex
  [EmployeeLocations.EmployeeFlex.Overview]: {
    title: 'Flex Program',
    analyticsTitle: 'employee-flex',
  },

  // Employee Micromobility
  [EmployeeLocations.EmployeeMicromobility.Overview]: {
    title: 'Micromobility',
    analyticsTitle: 'employee-micromobility',
  },
  [EmployeeLocations.EmployeeMicromobility.CheckoutConfirmation]: {
    title: 'Micromobility Checkout Confirmation',
    analyticsTitle: 'employee-micromobility-checkout-confirmation',
  },

  // Employee Transactions
  [EmployeeLocations.EmployeeTransactions.Overview]: {
    title: 'Transactions',
    analyticsTitle: 'employee-transactions',
  },

  // Employee Trips
  [EmployeeLocations.EmployeeTrips.Overview]: {
    title: 'Trips',
    analyticsTitle: 'employee-trips',
  },
  [EmployeeLocations.EmployeeTrips.AddTrip]: {
    title: 'Add Trip',
    analyticsTitle: 'employee-trips',
  },

  // Employee Leaderboards
  [EmployeeLocations.EmployeeLeaderboards.Overview]: {
    title: 'Leaderboards',
    analyticsTitle: 'employee-leaderboards',
  },

  // Employee Opt-Ins
  [EmployeeLocations.EmployeeOptIn.Overview]: {
    title: 'Opt-In',
    analyticsTitle: 'employee-optin',
  },

  // Employee Concierge
  [EmployeeLocations.EmployeeConcierge]: {
    title: 'Concierge',
    analyticsTitle: 'employee-concierge',
  },

  // Employee Reimbursement
  [EmployeeLocations.EmployeeReimbursement.Overview]: {
    title: 'Reimbursement',
    analyticsTitle: 'employee-reimbursement',
  },

  // Employee Transit Pass
  [EmployeeLocations.EmployeeTransitPass.Overview]: {
    title: 'Transit Pass',
    analyticsTitle: 'employee-transit-pass',
  },
}
